module.exports = __webpack_public_path__ + "img/review-8.267ca3b2.png";